import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomers, StateStatus } from '@guryou/redux';
import { resetState } from '../actions';
import { CUSTOMERS_GET_MANY } from '../types';
const useClients = function (stateSelector) {
  let noWlakinClients = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let rs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let notArchived = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  let active = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  let isApproved = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity
  } = useSelector(stateSelector);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getCustomers(notArchived, active, isApproved));
    }
  }, [active, dispatch, isApproved, notArchived, status]);
  useEffect(() => {
    return () => rs && dispatch(resetState(CUSTOMERS_GET_MANY));
  }, [dispatch, rs]);
  if (noWlakinClients) {
    return {
      data: (data || []).filter(x => (x === null || x === void 0 ? void 0 : x.id) && ((x === null || x === void 0 ? void 0 : x.id) !== null || (x === null || x === void 0 ? void 0 : x.id) !== undefined)) || [],
      status,
      version,
      entity
    };
  }
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useClients;